export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyD4dqRbmghOGZhkpi5ubMvHA3I23nuXSog',
    authDomain: 'sellmoapp.firebaseapp.com',
    databaseURL: 'https://sellmoapp.firebaseio.com',
    projectId: 'sellmoapp',
    storageBucket: 'sellmoapp.appspot.com',
    messagingSenderId: '901973097528',
    appId: '1:901973097528:web:f955129e4a724491c53acd'
  },
  sentryDSN: 'https://7ab2272c4e8d4a5e8074a25a03677ab0@sentry.io/1250410'
};
